import { createFileRoute } from '@tanstack/react-router';
import SignalEntityPage from '@/pages/SignalEntityPage.jsx';
import { SignalsError, SignalsPending } from '@/components/signals/SignalBits.jsx';
import { getSignalEntity } from '@/api';

function PersonRoute() {
  const prof = Route.useLoaderData();
  return <SignalEntityPage prof={prof} />;
}

export const Route = createFileRoute('/people/$id')({
  loader: ({ params }) => getSignalEntity('person', params.id),
  component: PersonRoute,
  pendingComponent: SignalsPending,
  pendingMs: 200,
  errorComponent: ({ error }) => <SignalsError title="Couldn’t load this person" error={error} />,
});
